import * as Sentry from '@sentry/react';
import { CriticalErrorFallback } from '../Abstracts/ErrorFallback/CriticalErrorFallback/CriticalErrorFallback';

export function RootErrorBoundary({ children }: { children: React.ReactNode }) {
    return (
      <Sentry.ErrorBoundary
        fallback={<CriticalErrorFallback />}
        beforeCapture={(scope, error) => {
          scope.setTag('boundary', 'root');
          scope.setTag('sentry_error_name', error instanceof Error ? error.name : 'Unknown');
          scope.setTag('environment', process.env.NODE_ENV);
          
          scope.setLevel('fatal');
        }}
      >
        {children}
      </Sentry.ErrorBoundary>
    );
  }